/** @format */

import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import AdditonalChargesService from "../../Services/AdditionalChargesService";
import SimpleReactValidator from "simple-react-validator";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";

export const CourierAdditionalCharges = () => {
  const [, setForceUpdate] = useState("");
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const [loader, setLoader] = useState(true);
  const [fedexList, setFedexList] = useState();
  const [ups, setUps] = useState();

  const history = useHistory();
  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  useEffect(() => {
    getItemList();
  }, []);

  const getItemList = () => {
    AdditonalChargesService.getCourieraddionalcharges().then((res) => {
      if (res.status) {
        setLoader(false);
        setFedexList(res.data);
      } else {
        setLoader(false);
      }
    });
  };

  const onchangeArray = (event, key) => {
    let { name, value } = event.target;

    let newArry = [...fedexList];
    
    newArry[key][name] = value

    // newArry.map((val, ind) => {
    //   for (const id in val) {
    //     if (Object.hasOwnProperty.call(val, id)) {
    //       if (ind === key) {
    //         if (name === id) {
    //           val[id] = value;
    //         }
    //       }
    //     }
    //   }
    // });
    setFedexList(newArry);
  };
  const submitHandler = (key, listdata) => {
    console.log('dfgf')
    var check_value = [];
    if (key === "Fedex") {
      check_value = [
        "vendor_type",
        "fuel_charges",
        "govt_tax",
        "peak_search_charge_express_freight_shipment",
        "peak_search_charge_express_freight_shipment_min",
        "peak_search_charge_express_shipment",
        "peak_search_charge_express_shipment_min",
      ];
      var validate =
        validator.current.fieldValid(key + " fuel charges") &&
        validator.current.fieldValid(key + " Govt. tax") &&
        validator.current.fieldValid(key + " express shipment") &&
        validator.current.fieldValid(key + " express shipment min") &&
        validator.current.fieldValid(key + " freight shipment") &&
        validator.current.fieldValid(key + " freight shipment min")
    } else if (key === "Ups") {
      check_value = ["vendor_type", "fuel_charges", "govt_tax"];
      validate =
        validator.current.fieldValid(key + " fuel charges") &&
        validator.current.fieldValid(key + " Govt. tax");
    } else if (key === "Tnt") {
      check_value = ["vendor_type", "fuel_charges","peak_search_charge_express_shipment","haldling_in_out", "pallet_charges"];
      validate =
      validator.current.fieldValid(key + " fuel charges") &&
      validator.current.fieldValid(key + " express shipment") &&
      validator.current.fieldValid(key + " handling in/out") &&
      validator.current.fieldValid(key + " pallet charges");
    }else if (key === "Dhl") {
      check_value = [
        "vendor_type",
        "fuel_charges",
        "govt_tax",
        "peak_search_charge_express_freight_shipment",
        "peak_search_charge_express_freight_shipment_min",
        "peak_search_charge_express_shipment",
        "peak_search_charge_express_shipment_min",
      ];
      validate =
      validator.current.fieldValid(key + " fuel charges") &&
      validator.current.fieldValid(key + " Govt. tax") &&
      validator.current.fieldValid(key + " express shipment") &&
      validator.current.fieldValid(key + " express shipment min") &&
      validator.current.fieldValid(key + " freight shipment") &&
      validator.current.fieldValid(key + " freight shipment min")
    }

    var postData = { id: listdata["_id"] };
    check_value.forEach(function (e) {
      postData[e] = listdata[e];
    });

    if (validate) {
      AdditonalChargesService.updateCourieraddionalcharges(postData).then(
        (res) => {
          if (res.status) {
            history.push("/courier-additional-charges");
            toast.success("Additional charges updated successfully");
          } else {
            toast.error(res.message);
          }
        }
      );
    } else {
      validator.current.showMessages();
    }
  };


  return (
    <>
      <div class="d-flex justify-content-end mb-3">
        {/* <button
          class="btn btn-primary w-sm waves-effect waves-light"
          onClick={() => history.push("add-courier-additonal-charges")}
        >
          Add Additional Charges
        </button> */}
      </div>
      <div className="row">
        {fedexList &&
          fedexList.map((item, key) => {
            return (
              <div className="col-lg-6">
                <div className="card">
                  <div class="d-flex mb-3 align-items-center card-header">
                    <h5 class="mb-0 me-auto">
                      Additional Charges{" "}
                      <b>
                        <small className="text-muted">
                          ({item.vendor_type=="Tnt"?'Land Mode':item.vendor_type})
                        </small>
                      </b>
                    </h5>
                  </div>
                  <div className="card-body">
                  <h5>{item.vendor_type==="Tnt" && "Land Consolidation"}</h5>
                  <hr className="mt-1 mb-4" style={{display: item.vendor_type==="Tnt" ? 'block' : 'none'}} />

                    {(item.vendor_type == "Ups" ||
                      item.vendor_type == "Fedex" ||
                      item.vendor_type == "Tnt" || 
                      item.vendor_type == "Dhl") && (
                      <>
                        <div className="row">
                          <div className="col-6">
                            <label>Vendor Type</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Fuel Charges"
                              value={item.vendor_type}
                              readOnly
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {(item.vendor_type == "Ups" ||
                      item.vendor_type == "Fedex" ||
                      item.vendor_type == "Tnt" ||
                      item.vendor_type == "Dhl") && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Fuel charges <small className="muted">%</small>
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Fuel Charges"
                              value={item.fuel_charges}
                              name="fuel_charges"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " fuel charges",
                              item.fuel_charges,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {(item.vendor_type == "Ups" ||
                      item.vendor_type == "Fedex"||
                      item.vendor_type == "Dhl") && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Government Tax <small className="muted">%</small>
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Government Tax"
                              value={item.govt_tax}
                              name="govt_tax"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " Govt. tax",
                              item.govt_tax,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {(item.vendor_type == "Fedex" ||
                      item.vendor_type == "Tnt" ||
                      item.vendor_type == "Dhl") && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Peak Season Surcharge Express Shipment{" "}
                              <small className="muted">(AED)</small> /Kg
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.peak_search_charge_express_shipment}
                              name="peak_search_charge_express_shipment"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " express shipment",
                              item.peak_search_charge_express_shipment,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {(item.vendor_type == "Fedex" ||
                      item.vendor_type == "Dhl") && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Peak Season Surcharge Express Shipment min{" "}
                              <small className="muted">(AED)</small>
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.peak_search_charge_express_shipment_min
                              }
                              name="peak_search_charge_express_shipment_min"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " express shipment min",
                              item.peak_search_charge_express_shipment_min,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {(item.vendor_type == "Fedex"||
                      item.vendor_type == "Dhl") && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Peak Season Surcharge Express Freight Shipment{" "}
                              <small className="muted">(AED)</small> /Kg
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.peak_search_charge_express_freight_shipment
                              }
                              name="peak_search_charge_express_freight_shipment"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " freight shipment",
                              item.peak_search_charge_express_freight_shipment,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {(item.vendor_type == "Fedex"||
                      item.vendor_type == "Dhl") && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Peak Season Surcharge Express Freight Shipment min{" "}
                              <small className="muted">(AED)</small>
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.peak_search_charge_express_freight_shipment_min
                              }
                              name="peak_search_charge_express_freight_shipment_min"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " freight shipment min",
                              item.peak_search_charge_express_freight_shipment_min,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {item.vendor_type == "Tnt" && ( <>
                         <h5 className="mt-4">Land Express</h5> 
                      {/* <div className="card-header mt-2"> */}
                        {/* <label className="text-muted mb-0">Destination cross border charges :-</label> */}
                        <hr className="mt-1" />
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Handling In/Out
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.haldling_in_out
                              }
                              name="haldling_in_out"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " handling in/out",
                              item.haldling_in_out,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Pallet Charges
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.pallet_charges
                              }
                              name="pallet_charges"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " pallet charges",
                              item.pallet_charges,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                      {/* </div> */}
                       </>
                    )}

                    {
                       (CheckAccess(215,"edit") || user_type === "SUPERADMIN") && 
                    <button
                      class="btn btn-primary ms-auto d-block mt-3"
                      onClick={() => submitHandler(item.vendor_type, item)}
                    >
                      Update{" "}
                    </button>
                    }

                  </div>
                </div>
              </div>
            );
          })}
        <Loader isShow={loader} />
      </div>
    </>
  );
};
